import { Injectable } from "@angular/core";
import { RequestsOperationsService } from "@edp-services/requests-operations.service";
import { EAssistanceRequestActions, SetEquipments, SetSymptoms } from "@edp-store/actions/assistence-request.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class AssistanceRequestEffects {

    @Effect()
    loadSymptoms$ = this.actions$.pipe(
        ofType(EAssistanceRequestActions.GetSymptoms),
        switchMap(() =>
            this.requestsOperationsService.getSymptoms().pipe(
                catchError((error: Error) => of(error))
            )
        ),
        switchMap((response) => {
            if (response instanceof Error) {
                return of(new SetSymptoms([]));
            } else {
                return of(new SetSymptoms(response.Result.Collection));
            }
        })
    );

    @Effect()
    loadEquipments$ = this.actions$.pipe(
        ofType(EAssistanceRequestActions.GetEquipments),
        switchMap(() =>
            this.requestsOperationsService.getEquipments().pipe(
                catchError((error: Error) => of(error))
            )
        ),
        switchMap((response) => {
            if (response instanceof Error) {
                return of(new SetEquipments([]));
            } else {
                return of(new SetEquipments(response.Result.Collection));
            }
        })
    );

    constructor(private actions$: Actions, private requestsOperationsService: RequestsOperationsService) { }
}
